import Vue from 'vue'
import Vuex from 'vuex'
import db from '@/Firebase/init'
import firebase from 'firebase'

Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        urlToTradera: 'https://www.tradera.com/profile/items/1019190/toppare?itemType=Auction',
        user: null
    },

    getters: {
        user(state) {
            return state.user
        } 
    },

    mutations: {
        setUser(state, payload) {
            state.user = payload
        }
    },

    actions: {
        logUserIn({commit}, payload) {
            firebase.auth().signInWithEmailAndPassword(payload.username, payload.password)
            .then((user) => {
                const newUser = {
                    id: user.user.uid
                }
                commit('setUser', newUser)

            }).catch(error => {
                console.log(error.message)
            })
        }
    }
})


// WEBPACK FOOTER //
// ./src/store/store.js